module.exports = __webpack_public_path__ + "img/creaNewPro.ed70a207.svg";